/**
 * Prefixes a root-relative app path with the reverse-proxy base path so
 * client-side fetches and raw anchors resolve under the prefix (e.g.
 * `/jobs/api/...`, `/jobs/de/job/...`).
 *
 * Next's `basePath` rewrites routes (pages, API handlers, assets) and
 * `next/link` hrefs under the prefix, but it does NOT rewrite root-relative
 * URLs passed to `fetch()` or to a raw `<a href>` — those resolve against the
 * origin root, drop the prefix, and 404. Wrap such values with this helper.
 *
 * Reads `process.env.NEXT_PUBLIC_BASE_PATH` directly (Next inlines
 * `NEXT_PUBLIC_*` at build time) rather than the validated env module, so this
 * leaf util stays import-light and does not pull env validation into the unit
 * tests of every consumer. Empty / unset for apps mounted at root → no-op.
 *
 * Client-safe only: a bare prefixed path has no host and cannot be fetched
 * server-side — use `getFetchContext` for SSR loopback fetches instead.
 */
export function withBasePath(path: string): string {
  return `${process.env.NEXT_PUBLIC_BASE_PATH ?? ""}${path}`;
}
